import React from "react";
import "./ResponsiveTable.css";

export default function ResponsiveTable({ data = [], headers = [], renderItem }) {
  if (!data || data.length === 0) {
    return <p style={{ textAlign: "center", color: "#707070" }}>No data available</p>;
  }

  return (
    <div className="mobile-container-list">
      {data.map((item, idx) => {
        const mapped = renderItem(item);
        return (
          <div key={idx} className="mobile-card">
            {Object.keys(mapped).map((key, i) => (
              <div className="mobile-card-row" key={i}>
                <span className="mobile-label">{headers[i]}</span>
                <span className="mobile-value">{mapped[key] ?? "-"}</span>
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
}